// Refactored Perfume component with reusable components and cleaner structure
import React, { useEffect } from "react";
import "./Perfume.css";
import { useSEO } from "../../context/SEOContext";
import MenFoto from "./../../assets/perfume/parfumepagemen.webp";
import MenImage1 from "./../../assets/perfume/male-top.webp";
import MenImage2 from "./../../assets/perfume/male-middle.webp";
import MenImage3 from "./../../assets/perfume/male-base.webp";
import BannerMenBottom from "./../../assets/perfume/bannerbttom.webp";

import WomenFoto from "./../../assets/perfume/parfumpagewomen.webp";
import WomenImage1 from "./../../assets/perfume/female-top-1.webp";
import WomenImage2 from "./../../assets/perfume/female-middle.webp";
import WomenImage3 from "./../../assets/perfume/female-base.webp";
import BannerWomanBottom from "./../../assets/perfume/bannerbottomfemale.webp";

import Artboard1 from "./../../assets/perfume/artboard1.webp";
import Artboard2 from "./../../assets/perfume/artboard2.webp";
import Artboard3 from "./../../assets/perfume/artboard3.webp";

//import bannerImage from "./../../assets/perfume/parfumepagebanner.webp";
//import bannerImageMobil from "./../../assets/perfume/parfumepagebannermobile.webp";
import bannerImage from "./../../assets/perfume/banner1.webp";
import bannerImageMobil from "./../../assets/perfume/banner1mobile.webp";
import { useTranslation } from "react-i18next";
const NoteBlock = ({ image, title, notes }) => (
  <div className="d-flex align-items-center mt-4">
    <img src={image} alt={title} className="me-3 artbmoardsize" />
    <div>
      <p className="mb-1 fw-semibold">{title}</p>
      <p className="mb-0 text-muted">{notes}</p>
    </div>
  </div>
);

const PyramidSection = ({ image1, image2, image3 }) => {
  const { t } = useTranslation();
  const labels = [t("Top"), t("Middle"), t("Base")];
  return (
    <div className="row text-center">
      {[image1, image2, image3].map((img, idx) => (
        <div key={idx} className="col-lg-4 px-1">
          <div className="mb-2">
            <span className="fs-6">0{idx + 1}</span>
            <span className="fs-4 mx-1">{labels[idx]}</span>
          </div>
          <img
            src={img}
            alt={labels[idx]}
            className="w-100"
            style={{
              height: "400px",
              objectFit: "cover",
              objectPosition: "center",
              marginTop: 10,
              marginBottom: 20,
            }}
          />
        </div>
      ))}
    </div>
  );
};

const BannerOverlay = ({ img, text }) => (
  <div className="row mt-5">
    <div
      className="col-lg-12 px-0 position-relative"
      style={{ height: "440px" }}
    >
      <img
        src={img}
        alt="Mukemel Perfume for Men & Women"
        className="w-100 h-100"
      />
      <div className="position-absolute top-50 start-50 translate-middle text-center text-white perfumebannertext">
        <div className="bgbannercolor p-4">
          <p>{text}</p>
        </div>
      </div>
    </div>
  </div>
);

const AccordionSection = ({ gender, inspiration, id }) => {
  const { t } = useTranslation();
  return (
    <div className="mt-5">
      <div className="accordion" id={`accordion${id}`}>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`headingGender${id}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapseGender${id}`}
              aria-expanded="false"
              aria-controls={`collapseGender${id}`}
            >
              {t("Gender")}
            </button>
          </h2>
          <div
            id={`collapseGender${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`headingGender${id}`}
            data-bs-parent={`#accordion${id}`}
          >
            <div className="accordion-body">{gender}</div>
          </div>
        </div>
        <div className="accordion-item">
          <h2 className="accordion-header" id={`headingInspiration${id}`}>
            <button
              className="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target={`#collapseInspiration${id}`}
              aria-expanded="false"
              aria-controls={`collapseInspiration${id}`}
            >
              {t("Inspiration")}
            </button>
          </h2>
          <div
            id={`collapseInspiration${id}`}
            className="accordion-collapse collapse"
            aria-labelledby={`headingInspiration${id}`}
            data-bs-parent={`#accordion${id}`}
          >
            <div className="accordion-body">{inspiration}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Perfume = () => {
  const { t } = useTranslation();
  const setSeo = useSEO();
  useEffect(() => {
    setSeo({
      title: t("perfume.meta.title"),
      description: t("perfume.meta.description"),
      keywords: t("perfume.meta.keywords"),
      favicon: "/faviconnew.png", // ✅ burada favicon tanımlandı
      ogImage:
        "https://mukemel.com/static/media/brothers.c791973cd1c46d462816.webp",
      ogUrl: "https://mukemel.com/perfume",
      ogType: "perfume", // ya da 'website'
    });
  }, [setSeo, t]);
  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 pe-0 px-0 d-none d-sm-block">
            <a href="/category/perfume">
              <img
                src={bannerImage}
                alt="Mukemel perfume banner with man and woman applying fragrance"
                title="Mukemel Perfume - Sensual Fragrance for Men & Women"
                className="w-100 banner-img"
              />
            </a>
          </div>
          <div className="col-lg-12 pe-0 px-0 d-block d-sm-none">
            <a href="/category/perfume">
              <img
                src={bannerImageMobil}
                alt="Mukemel mobile perfume banner showing couple using fragrance"
                title="Mukemel Perfume – Luxury Scents for All"
                className="w-100 banner-img2"
              />
            </a>
          </div>
        </div>
        <h1 className="text-center fw-normal my-5 fs-5">
          <span dangerouslySetInnerHTML={{ __html: t("TitleText") }} />
        </h1>
      </div>
      <div className="container my-5">
        {/* Women Section */}
        <div className="row pt-5 pb-5 mt-5">
          <div className="col-lg-6 text-center px-0">
            <div className="position-relative d-block">
              <a href="/product/218">
                <img
                  src={WomenFoto}
                  className="w-100 mb-4"
                  alt="Perfume for Women perfume with raspberry, orange and amber notes"
                  title="Perfume for Women"
                />
                <p className="text-decoration-underline text-white mb-5 position-absolute bottom-0 start-50 translate-middle-x border border-light p-2 pe-4 px-4 rounded-2 fw-bold">
                  {t("View More")}
                </p>
              </a>
            </div>
          </div>
          <div className="col-lg-6 px-4">
            <h2 className="fs-5 mt-4">{t("Perfume for Women")}</h2>
            <NoteBlock
              image={Artboard1}
              title={t("Top")}
              notes={t("WomenTop")}
            />
            <NoteBlock
              image={Artboard2}
              title={t("Middle")}
              notes={t("WomenMiddle")}
            />
            <NoteBlock
              image={Artboard3}
              title={t("Base")}
              notes={t("WomenBase")}
            />
            <AccordionSection
              id="Women"
              gender={t("Women")}
              inspiration={t("WomenDesc")}
            />
          </div>
        </div>

        {/* Women Pyramid Section */}
        <div
          className="row align-items-center p-5 bgcolor2"
          style={{ minHeight: "447px" }}
        >
          <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column align-items-center justify-content-center text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <p className="mb-0 fs-5 fw-normal textcolorred">
                  {t("MenCharactersDesc")}
                  <p className="fs-3"> {t("Worththewait")}</p>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2">
            <div className="text-center mb-3">
              <h2 className="fs-5 mb-1">{t("MÜKEMEL Perfume by I&F")}</h2>
              <h3 className="fs-6 fw-light mb-0">{t("Main characters")}</h3>
            </div>
            <PyramidSection
              image1={WomenImage1}
              image2={WomenImage2}
              image3={WomenImage3}
            />
          </div>
        </div>

        <BannerOverlay img={BannerWomanBottom} text={t("WomenDesc")} />

        {/* Men Section */}
        <div className="row mt-5">
          <div className="col-lg-6 text-center px-0">
            <div className="position-relative d-block">
              <a href="/product/219">
                <img
                  src={MenFoto}
                  className="w-100 mb-4"
                  alt="Perfume for Men perfume with grapefruit, vanilla and amber notes"
                  title="Perfume for Men"
                />
                <p className="text-decoration-underline text-white mb-5 position-absolute bottom-0 start-50 translate-middle-x border border-light p-2 pe-4 px-4 rounded-2 fw-bold">
                  {t("View More")}
                </p>
              </a>
            </div>
          </div>
          <div className="col-lg-6 px-4">
            <h2 className="fs-5 mt-4">{t("Perfume for Men")}</h2>
            <NoteBlock image={Artboard1} title={t("Top")} notes={t("MenTop")} />
            <NoteBlock
              image={Artboard2}
              title={t("Middle")}
              notes={t("MenMiddle")}
            />
            <NoteBlock
              image={Artboard3}
              title={t("Base")}
              notes={t("MenBase")}
            />
            <AccordionSection
              id="Men"
              gender={t("Men")}
              inspiration={t("MenDesc")}
            />
          </div>
        </div>

        {/* Men Pyramid Section */}
        <div
          className="row mt-5 align-items-center bgcolor2 p-5"
          style={{ minHeight: "447px" }}
        >
          <div className="col-lg-6 order-2 order-lg-1 d-flex flex-column align-items-center justify-content-center text-center">
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <p className="mb-0 fs-5 fw-normal textcolorred">
                  {t("MenCharactersDesc")}
                  <p className="fs-3"> {t("Worththewait")}</p>
                </p>
              </div>
            </div>
          </div>
          <div className="col-lg-6 order-1 order-lg-2">
            <div className="text-center mb-3">
              <h2 className="fs-5 mb-1">{t("MÜKEMEL Perfume by I&F")}</h2>
              <h3 className="fs-6 fw-light mb-0">{t("Main characters")}</h3>
            </div>
            <PyramidSection
              image1={MenImage1}
              image2={MenImage2}
              image3={MenImage3}
            />
          </div>
        </div>

        <BannerOverlay img={BannerMenBottom} text={t("MenDesc")} />
      </div>

      {/* YouTube Section */}
      <div className="container mb-5 pe-0 px-0">
        <div className="row text-center">
          <div className="col-lg-6 mt-3">
            <h2 className="fs-5 mb-3">{t("Fragrance for men")}</h2>
            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.youtube.com/embed/a4ZC-MtSn3E"
                title="Mukemel Fragrance Ad for Men"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="col-lg-6 mt-3">
            <h2 className="fs-5 mb-3">{t("Fragrance for women")}</h2>
            <div className="ratio ratio-16x9">
              <iframe
                src="https://www.youtube.com/embed/rrYgEbCGV1Y"
                title="Mukemel Fragrance for Women"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Perfume;
